import React from "react";
import { setStepIndex, startTour } from "../redux/globalJoyrideSlice";

/* 🔹 Reusable bilingual content */
export const JoyrideContent = ({ en, hi }) => (
  <div>
    <div style={{ fontWeight: 500 }}>{en}</div>
    <div style={{ fontWeight: 500, marginTop: "4px" }}>{hi}</div>
  </div>
);

/* =====================================================
   📌 TEACHER PLANNER / TIMETABLE TOUR STEPS
   ===================================================== */

export const teacherPlannerTourSteps = () => [
  {
    target: '[data-tour="my-timetable-btn"]',
    placement: "right",
    disableBeacon: true,
    spotlightClicks: true,
    hideFooter: true,
    speechText: "Open your timetable.",
    content: (
      <JoyrideContent
        en="View your timetable."
        hi="अपनी समय-सारणी देखें।"
      />
    ),
  },
  {
    target: '[data-tour="select-class-step"]',
    placement: "bottom",
    disableBeacon: true,
    speechText: "Choose a class.",
    content: (
      <JoyrideContent
        en="Select a class."
        hi="कक्षा चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="select-section-step"]',
    placement: "bottom",
    disableBeacon: true,
    speechText: "Choose a section.",
    content: (
      <JoyrideContent
        en="Select the section."
        hi="अनुभाग चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="select-date-step"]',
    placement: "bottom",
    disableBeacon: true,
    showNext: true,
    speechText: "Pick a date.",
    content: (
      <JoyrideContent
        en="Select a date."
        hi="तारीख चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="timetable-table-step"]',
    placement: "top",
    disableBeacon: true,
    showNext: true,
    spotlightClicks: false,
    speechText: "This is your timetable.",
    content: (
      <JoyrideContent
        en="Your timetable is shown here."
        hi="आपकी समय-सारणी यहाँ दिखाई गई है।"
      />
    ),
  },
];

/* =====================================================
   📌 ADMIN – SYLLABUS LIST
   ===================================================== */

export const adminSyllabusTourSteps = () => [
  {
    target: '[data-tour="add-syllabus-btn"]',
    placement: "right",
    disableBeacon: true,
    spotlightClicks: true,
    hideFooter: true,
    speechText: "Add a new syllabus.",
    content: (
      <JoyrideContent
        en="Add a new syllabus."
        hi="नया सिलेबस जोड़ें।"
      />
    ),
  },
];

/* =====================================================
   📌 ADMIN – UPLOAD SYLLABUS FORM
   ===================================================== */

export const adminUploadSyllabusFormTourSteps = () => [
  {
    target: '[data-tour="upload-select-teacher"]',
    placement: "right",
    disableBeacon: true,
    speechText: "Select a teacher(choose super admin Rohan kumar)",
    content: (
      <JoyrideContent
        en="Select the teacher(choose super admin Rohan kumar)."
        hi="शिक्षक चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="upload-select-class"]',
    placement: "right",
    speechText: "Select a class.",
    content: (
      <JoyrideContent
        en="Select the class."
        hi="कक्षा चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="upload-select-subject"]',
    placement: "right",
    speechText: "Select a subject.",
    content: (
      <JoyrideContent
        en="Select the subject."
        hi="विषय चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="download-sample-excel"]',
    placement: "right",
    speechText: "Download sample format.",
    content: (
      <JoyrideContent
        en="Download sample Excel."
        hi="सैंपल Excel डाउनलोड करें।"
      />
    ),
  },
  {
    target: '[data-tour="upload-excel-file"]',
    placement: "right",
    speechText: "Upload the file.",
    content: (
      <JoyrideContent
        en="Upload syllabus file."
        hi="सिलेबस फ़ाइल अपलोड करें।"
      />
    ),
  },
  {
    target: '[data-tour="upload-submit-btn"]',
    placement: "right",
    speechText: "Submit the syllabus.",
    content: (
      <JoyrideContent
        en="Submit the syllabus."
        hi="सिलेबस सबमिट करें।"
      />
    ),
  },
];

/* =====================================================
   📌 ADMIN – SYLLABUS STAGE 3
   ===================================================== */

export const adminSyllabusStage3TourSteps = () => [
  {
    target: '[data-tour="syllabus-periods-input"]',
    placement: "right",
    disableBeacon: true,
    showNext: true,
    speechText: "Enter chapter periods.",
    content: (
      <JoyrideContent
        en="Enter periods for each chapter."
        hi="प्रत्येक अध्याय के लिए पीरियड्स दर्ज करें।"
      />
    ),
  },
  {
    target: '[data-tour="syllabus-submit-btn"]',
    placement: "top",
    speechText: "Review and submit.",
    content: (
      <JoyrideContent
        en="Review and submit."
        hi="जांचें और सबमिट करें।"
      />
    ),
  },
];

/* =====================================================
   📌 ADMIN – AFTER SUBMIT (SELECT FLOW)
   ===================================================== */

export const adminSyllabusTourSteps2 = () => [
  {
    target: '[data-tour="select-teacher-step"]',
    placement: "bottom",
    disableBeacon: true,
    speechText: "Select a teacher.",
    content: (
      <JoyrideContent
        en="Select a teacher."
        hi="शिक्षक चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="select-class-step"]',
    placement: "bottom",
    speechText: "Select a class.",
    content: (
      <JoyrideContent
        en="Select the class."
        hi="कक्षा चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="select-subject-step"]',
    placement: "bottom",
    speechText: "Select a subject.",
    content: (
      <JoyrideContent
        en="Select the subject."
        hi="विषय चुनें।"
      />
    ),
  },
  {
  target: '[data-tour="syllabus-plan-table"]',
  placement: "right",
  disableBeacon: true,
  showNext: true,
  speechText: "This is the syllabus plan.",
  content: (
    <JoyrideContent
      en="This is the syllabus plan."
      hi="यह सिलेबस योजना है।"
    />
  ),
}

];

export const weeklyLessonsTourSteps = ({
  dispatch,
  navigate,
  stopTour,
}) => [

  {
    target: '[data-tour="weekly-tab-my"]',
    placement: "right",
    disableBeacon: true,
    speechText: "Open your weekly plan.",
    content: (
      <JoyrideContent
        en="Open your weekly plan."
        hi="अपनी साप्ताहिक योजना खोलें।"
      />
    ),
  },
  {
    target: '[data-tour="weekly-select-class"]',
    placement: "bottom",
    speechText: "Select class.",
    content: (
      <JoyrideContent
        en="Select class."
        hi="कक्षा चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="weekly-select-section"]',
    placement: "bottom",
    speechText: "Select section.",
    content: (
      <JoyrideContent
        en="Select section."
        hi="सेक्शन चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="weekly-select-subject"]',
    placement: "bottom",
    speechText: "Select subject.",
    content: (
      <JoyrideContent
        en="Select subject."
        hi="विषय चुनें।"
      />
    ),
  },
   // 🔹 NEW STEP – TOPIC COLUMN
  {
    target: '[data-tour="weekly-topic-column"]',
    placement: "top",
    showNext: true,
    speechText: "Add or edit lesson topics here.",
    content: (
      <JoyrideContent
        en="Add or edit topics taught in each period."
        hi="प्रत्येक पीरियड में पढ़ाए गए विषय जोड़ें या संपादित करें।"
      />
    ),
  },
 
{
    target: '[data-tour="topic-details-step"]',
    placement: "right",
    disableBeacon: true,
    showNext: true,
    speechText: "Enter topic details.",
    content: (
      <JoyrideContent
        en="Enter the topic details for this period."
        hi="इस पीरियड के लिए विषय का विवरण दर्ज करें।"
      />
    ),
  },
  {
    target: '[data-tour="topic-save-step"]',
    placement: "right",
    disableBeacon: true,
    hideFooter: true,
    speechText: "Save the topic.",
    content: (
      <JoyrideContent
        en="Click here to save the topic."
        hi="विषय को सेव करने के लिए यहाँ क्लिक करें।"
      />
    ),
  },
  {
  target: "body",
  placement: "center",
  disableBeacon: true,
  hideFooter: true,
  disableOverlayClose: true,
  content: (
    <div style={{ textAlign: "center", minWidth: 300 }}>
      <h6>Do you want to add another topic?</h6>
      <p style={{ fontSize: 13, color: "#6b7280" }}>
        क्या आप एक और विषय जोड़ना चाहते हैं?
      </p>

      <div className="d-flex justify-content-center gap-3 mt-3">
        <button
          className="btn btn-primary btn-sm"
          onClick={() => {
            // YES → stay on Topic column
            dispatch(setStepIndex(4)); 
          }}
        >
          Yes / हाँ
        </button>

        <button
          className="btn btn-secondary btn-sm"
          onClick={() => {
            // NO → go to Homework column
            dispatch(setStepIndex(8));
          }}
        >
          No / नहीं
        </button>
      </div>
    </div>
  ),
},

  // 🔹 NEW STEP – HOMEWORK COLUMN
  {
    target: '[data-tour="weekly-homework-column"]',
    placement: "top",
    showNext: true,
    speechText: "Assign homework here.",
    content: (
      <JoyrideContent
        en="Add or update homework for students."
        hi="विद्यार्थियों के लिए होमवर्क जोड़ें या अपडेट करें।"
      />
    ),
  },

 {
    target: '[data-tour="homework-details-step"]',
    placement: "right",
    disableBeacon: true,
    showNext: true,
    speechText: "Enter homework details.",
    content: (
      <JoyrideContent
        en="Enter homework details for this period."
        hi="इस पीरियड के लिए होमवर्क का विवरण दर्ज करें।"
      />
    ),
  },
  {
    target: '[data-tour="homework-save-step"]',
    placement: "right",
    disableBeacon: true,
    hideFooter: true,
    speechText: "Save the homework.",
    content: (
      <JoyrideContent
        en="Click here to save the homework."
        hi="होमवर्क सेव करने के लिए यहाँ क्लिक करें।"
      />
    ),
  },
  {
  target: "body",
  placement: "center",
  disableBeacon: true,
  hideFooter: true,
  disableOverlayClose: true,
  content: (
    <div style={{ textAlign: "center", minWidth: 300 }}>
      <h6>Do you want to add another topic?</h6>
      <p style={{ fontSize: 13, color: "#6b7280" }}>
        क्या आप एक और विषय जोड़ना चाहते हैं?
      </p>

      <div className="d-flex justify-content-center gap-3 mt-3">
        <button
          className="btn btn-primary btn-sm"
          onClick={() => {
            // YES → stay on Topic column
            dispatch(setStepIndex(8)); 
          }}
        >
          Yes / हाँ
        </button>

        <button
          className="btn btn-secondary btn-sm"
          onClick={() => {
            dispatch(stopTour());
                
                // 2. Use a tiny timeout to let Joyride clean up its DOM references
                setTimeout(() => {
                  navigate("/allHomeworks");
                }, 100); 
          }}
        >
          No / नहीं
        </button>
      </div>
    </div>
  ),
},
];

export const myProjectsTourSteps = () => [
  {
    target: '[data-tour="projects-tab-my"]',
    placement: "right",
    disableBeacon: true,
    spotlightClicks: true,
    speechText: "Open My Projects.",
    content: (
      <JoyrideContent
        en="Click here to view your projects."
        hi="अपने प्रोजेक्ट देखने के लिए यहाँ क्लिक करें।"
      />
    ),
  },

  {
    target: '[data-tour="projects-select-class"]',
    placement: "bottom",
    disableBeacon: true,
    speechText: "Select class.",
    content: (
      <JoyrideContent
        en="Select the class."
        hi="कक्षा चुनें।"
      />
    ),
  },

  {
    target: '[data-tour="projects-select-section"]',
    placement: "right",
    disableBeacon: true,
    speechText: "Select section.",
    content: (
      <JoyrideContent
        en="Select the section."
        hi="अनुभाग चुनें।"
      />
    ),
  },

  {
    target: '[data-tour="projects-table"]',
    placement: "top",
    disableBeacon: true,
    showNext: true,
    speechText: "Your projects are listed here.",
    content: (
      <JoyrideContent
        en="Your projects are listed here."
        hi="यहाँ आपके प्रोजेक्ट सूचीबद्ध हैं।"
      />
    ),
  },
];

export const myHomeworksTourSteps = () => [
  {
    target: '[data-tour="homeworks-tab-my"]',
    placement: "right",
    disableBeacon: true,
    spotlightClicks: true,
    speechText: "Open My Homeworks.",
    content: (
      <JoyrideContent
        en="Open My Homeworks."
        hi="मेरे होमवर्क खोलें।"
      />
    ),
  },
  {
    target: '[data-tour="homeworks-select-class"]',
    placement: "right",
    disableBeacon: true,
    speechText: "Select class.",
    content: (
      <JoyrideContent
        en="Select class."
        hi="कक्षा चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="homeworks-select-section"]',
    placement: "right",
    disableBeacon: true,
    speechText: "Select section.",
    content: (
      <JoyrideContent
        en="Select section."
        hi="सेक्शन चुनें।"
      />
    ),
  },
  {
    target: '[data-tour="homeworks-table"]',
    placement: "top",
    disableBeacon: true,
    isFinalStep:true,
    speechText: "Your homeworks are listed here.",
    content: (
      <JoyrideContent
        en="Your homeworks are listed here."
        hi="यहाँ आपके होमवर्क दिखाए गए हैं।"
      />
    ),
  },
];



// import React from "react";
// import { setStepIndex } from "../redux/globalJoyrideSlice";

// /* =====================================================
//    📱 RESPONSIVE PLACEMENT (DESKTOP UNCHANGED)
//    ===================================================== */

// const isMobile = () => window.innerWidth <= 768;

// const responsivePlacement = (desktop) => {
//   if (!isMobile()) return desktop;

//   switch (desktop) {
//     case "right":
//     case "left":
//     case "top":
//       return "bottom";
//     case "center":
//       return "center";
//     default:
//       return desktop;
//   }
// };

// /* 🔹 Reusable bilingual content */
// export const JoyrideContent = ({ en, hi }) => (
//   <div>
//     <div style={{ fontWeight: 500 }}>{en}</div>
//     <div style={{ fontWeight: 500, marginTop: 4 }}>{hi}</div>
//   </div>
// );

// /* =====================================================
//    📌 TEACHER PLANNER / TIMETABLE
//    ===================================================== */

// export const teacherPlannerTourSteps = () => [
//   {
//     target: '[data-tour="my-timetable-btn"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     spotlightClicks: true,
//     hideFooter: true,
//     speechText: "Open your timetable.",
//     content: <JoyrideContent en="View your timetable." hi="अपनी समय-सारणी देखें।" />,
//   },
//   {
//     target: '[data-tour="select-class-step"]',
//     placement: responsivePlacement("bottom"),
//     disableBeacon: true,
//     speechText: "Choose a class.",
//     content: <JoyrideContent en="Select a class." hi="कक्षा चुनें।" />,
//   },
//   {
//     target: '[data-tour="select-section-step"]',
//     placement: responsivePlacement("bottom"),
//     disableBeacon: true,
//     speechText: "Choose a section.",
//     content: <JoyrideContent en="Select the section." hi="अनुभाग चुनें।" />,
//   },
//   {
//     target: '[data-tour="select-date-step"]',
//     placement: responsivePlacement("bottom"),
//     disableBeacon: true,
//     showNext: true,
//     speechText: "Pick a date.",
//     content: <JoyrideContent en="Select a date." hi="तारीख चुनें।" />,
//   },
//   {
//     target: '[data-tour="timetable-table-step"]',
//     placement: responsivePlacement("top"),
//     disableBeacon: true,
//     showNext: true,
//     speechText: "This is your timetable.",
//     content: <JoyrideContent en="Your timetable is shown here." hi="आपकी समय-सारणी यहाँ दिखाई गई है।" />,
//   },
// ];

// /* =====================================================
//    📌 ADMIN – SYLLABUS LIST
//    ===================================================== */

// export const adminSyllabusTourSteps = () => [
//   {
//     target: '[data-tour="add-syllabus-btn"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     spotlightClicks: true,
//     hideFooter: true,
//     speechText: "Add a new syllabus.",
//     content: <JoyrideContent en="Add a new syllabus." hi="नया सिलेबस जोड़ें।" />,
//   },
// ];

// /* =====================================================
//    📌 ADMIN – UPLOAD SYLLABUS FORM
//    ===================================================== */

// export const adminUploadSyllabusFormTourSteps = () => [
//   {
//     target: '[data-tour="upload-select-teacher"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     speechText: "Select a teacher.",
//     content: <JoyrideContent en="Select the teacher." hi="शिक्षक चुनें।" />,
//   },
//   {
//     target: '[data-tour="upload-select-class"]',
//     placement: responsivePlacement("right"),
//     speechText: "Select a class.",
//     content: <JoyrideContent en="Select the class." hi="कक्षा चुनें।" />,
//   },
//   {
//     target: '[data-tour="upload-select-subject"]',
//     placement: responsivePlacement("right"),
//     speechText: "Select a subject.",
//     content: <JoyrideContent en="Select the subject." hi="विषय चुनें।" />,
//   },
//   {
//     target: '[data-tour="download-sample-excel"]',
//     placement: responsivePlacement("right"),
//     speechText: "Download sample format.",
//     content: <JoyrideContent en="Download sample Excel." hi="सैंपल Excel डाउनलोड करें।" />,
//   },
//   {
//     target: '[data-tour="upload-excel-file"]',
//     placement: responsivePlacement("right"),
//     speechText: "Upload the file.",
//     content: <JoyrideContent en="Upload syllabus file." hi="सिलेबस फ़ाइल अपलोड करें।" />,
//   },
//   {
//     target: '[data-tour="upload-submit-btn"]',
//     placement: responsivePlacement("right"),
//     speechText: "Submit the syllabus.",
//     content: <JoyrideContent en="Submit the syllabus." hi="सिलेबस सबमिट करें।" />,
//   },
// ];

// /* =====================================================
//    📌 ADMIN – SYLLABUS STAGE 3
//    ===================================================== */

// export const adminSyllabusStage3TourSteps = () => [
//   {
//     target: '[data-tour="syllabus-periods-input"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     showNext: true,
//     speechText: "Enter chapter periods.",
//     content: <JoyrideContent en="Enter periods for each chapter." hi="प्रत्येक अध्याय के लिए पीरियड्स दर्ज करें।" />,
//   },
//   {
//     target: '[data-tour="syllabus-submit-btn"]',
//     placement: responsivePlacement("top"),
//     speechText: "Review and submit.",
//     content: <JoyrideContent en="Review and submit." hi="जांचें और सबमिट करें।" />,
//   },
// ];

// /* =====================================================
//    📌 ADMIN – AFTER SUBMIT
//    ===================================================== */

// export const adminSyllabusTourSteps2 = () => [
//   {
//     target: '[data-tour="select-teacher-step"]',
//     placement: responsivePlacement("bottom"),
//     disableBeacon: true,
//     speechText: "Select a teacher.",
//     content: <JoyrideContent en="Select a teacher." hi="शिक्षक चुनें।" />,
//   },
//   {
//     target: '[data-tour="select-class-step"]',
//     placement: responsivePlacement("bottom"),
//     speechText: "Select a class.",
//     content: <JoyrideContent en="Select the class." hi="कक्षा चुनें।" />,
//   },
//   {
//     target: '[data-tour="select-subject-step"]',
//     placement: responsivePlacement("bottom"),
//     speechText: "Select a subject.",
//     content: <JoyrideContent en="Select the subject." hi="विषय चुनें।" />,
//   },
//   {
//     target: '[data-tour="syllabus-plan-table"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     showNext: true,
//     speechText: "This is the syllabus plan.",
//     content: <JoyrideContent en="This is the syllabus plan." hi="यह सिलेबस योजना है।" />,
//   },
// ];

// /* =====================================================
//    📌 WEEKLY LESSONS (FULL FLOW)
//    ===================================================== */

// export const weeklyLessonsTourSteps = ({ dispatch, navigate, stopTour }) => [
//   {
//     target: '[data-tour="weekly-tab-my"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     speechText: "Open your weekly plan.",
//     content: <JoyrideContent en="Open your weekly plan." hi="अपनी साप्ताहिक योजना खोलें।" />,
//   },
//   {
//     target: '[data-tour="weekly-select-class"]',
//     placement: responsivePlacement("bottom"),
//     speechText: "Select class.",
//     content: <JoyrideContent en="Select class." hi="कक्षा चुनें।" />,
//   },
//   {
//     target: '[data-tour="weekly-select-section"]',
//     placement: responsivePlacement("bottom"),
//     speechText: "Select section.",
//     content: <JoyrideContent en="Select section." hi="सेक्शन चुनें।" />,
//   },
//   {
//     target: '[data-tour="weekly-select-subject"]',
//     placement: responsivePlacement("bottom"),
//     speechText: "Select subject.",
//     content: <JoyrideContent en="Select subject." hi="विषय चुनें।" />,
//   },
//   {
//     target: '[data-tour="weekly-topic-column"]',
//     placement: responsivePlacement("top"),
//     showNext: true,
//     speechText: "Add or edit lesson topics here.",
//     content: <JoyrideContent en="Add or edit topics taught in each period." hi="प्रत्येक पीरियड में पढ़ाए गए विषय जोड़ें या संपादित करें।" />,
//   },
//   {
//     target: '[data-tour="topic-details-step"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     showNext: true,
//     speechText: "Enter topic details.",
//     content: <JoyrideContent en="Enter the topic details for this period." hi="इस पीरियड के लिए विषय का विवरण दर्ज करें।" />,
//   },
//   {
//     target: '[data-tour="topic-save-step"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     hideFooter: true,
//     speechText: "Save the topic.",
//     content: <JoyrideContent en="Click here to save the topic." hi="विषय को सेव करने के लिए यहाँ क्लिक करें।" />,
//   },
//   {
//     target: "body",
//     placement: "center",
//     disableBeacon: true,
//     disableOverlayClose: true,
//     content: (
//       <div style={{ textAlign: "center", minWidth: 280 }}>
//         <h6>Do you want to add another topic?</h6>
//         <p style={{ fontSize: 13, color: "#6b7280" }}>
//           क्या आप एक और विषय जोड़ना चाहते हैं?
//         </p>
//         <div className="d-flex justify-content-center gap-3 mt-3">
//           <button className="btn btn-primary btn-sm" onClick={() => dispatch(setStepIndex(4))}>
//             Yes / हाँ
//           </button>
//           <button className="btn btn-secondary btn-sm" onClick={() => dispatch(setStepIndex(8))}>
//             No / नहीं
//           </button>
//         </div>
//       </div>
//     ),
//   },
//   {
//     target: '[data-tour="weekly-homework-column"]',
//     placement: responsivePlacement("top"),
//     showNext: true,
//     speechText: "Assign homework here.",
//     content: <JoyrideContent en="Add or update homework for students." hi="विद्यार्थियों के लिए होमवर्क जोड़ें या अपडेट करें।" />,
//   },
//   {
//     target: '[data-tour="homework-details-step"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     showNext: true,
//     speechText: "Enter homework details.",
//     content: <JoyrideContent en="Enter homework details for this period." hi="इस पीरियड के लिए होमवर्क का विवरण दर्ज करें।" />,
//   },
//   {
//     target: '[data-tour="homework-save-step"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     hideFooter: true,
//     speechText: "Save the homework.",
//     content: <JoyrideContent en="Click here to save the homework." hi="होमवर्क सेव करने के लिए यहाँ क्लिक करें।" />,
//   },
//   {
//     target: "body",
//     placement: "center",
//     disableBeacon: true,
//     disableOverlayClose: true,
//     content: (
//       <div style={{ textAlign: "center", minWidth: 280 }}>
//         <h6>Do you want to add another topic?</h6>
//         <p style={{ fontSize: 13, color: "#6b7280" }}>
//           क्या आप एक और विषय जोड़ना चाहते हैं?
//         </p>
//         <div className="d-flex justify-content-center gap-3 mt-3">
//           <button className="btn btn-primary btn-sm" onClick={() => dispatch(setStepIndex(8))}>
//             Yes / हाँ
//           </button>
//           <button
//             className="btn btn-secondary btn-sm"
//             onClick={() => {
//               stopTour();
//               setTimeout(() => navigate("/allHomeworks"), 100);
//             }}
//           >
//             No / नहीं
//           </button>
//         </div>
//       </div>
//     ),
//   },
// ];

// /* =====================================================
//    📌 MY PROJECTS
//    ===================================================== */

// export const myProjectsTourSteps = () => [
//   {
//     target: '[data-tour="projects-tab-my"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     spotlightClicks: true,
//     speechText: "Open My Projects.",
//     content: <JoyrideContent en="Click here to view your projects." hi="अपने प्रोजेक्ट देखने के लिए यहाँ क्लिक करें।" />,
//   },
//   {
//     target: '[data-tour="projects-select-class"]',
//     placement: responsivePlacement("bottom"),
//     disableBeacon: true,
//     speechText: "Select class.",
//     content: <JoyrideContent en="Select the class." hi="कक्षा चुनें।" />,
//   },
//   {
//     target: '[data-tour="projects-select-section"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     speechText: "Select section.",
//     content: <JoyrideContent en="Select the section." hi="अनुभाग चुनें।" />,
//   },
//   {
//     target: '[data-tour="projects-table"]',
//     placement: responsivePlacement("top"),
//     disableBeacon: true,
//     showNext: true,
//     speechText: "Your projects are listed here.",
//     content: <JoyrideContent en="Your projects are listed here." hi="यहाँ आपके प्रोजेक्ट सूचीबद्ध हैं।" />,
//   },
// ];

// /* =====================================================
//    📌 MY HOMEWORKS
//    ===================================================== */

// export const myHomeworksTourSteps = () => [
//   {
//     target: '[data-tour="homeworks-tab-my"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     spotlightClicks: true,
//     speechText: "Open My Homeworks.",
//     content: <JoyrideContent en="Open My Homeworks." hi="मेरे होमवर्क खोलें।" />,
//   },
//   {
//     target: '[data-tour="homeworks-select-class"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     speechText: "Select class.",
//     content: <JoyrideContent en="Select class." hi="कक्षा चुनें।" />,
//   },
//   {
//     target: '[data-tour="homeworks-select-section"]',
//     placement: responsivePlacement("right"),
//     disableBeacon: true,
//     speechText: "Select section.",
//     content: <JoyrideContent en="Select section." hi="सेक्शन चुनें।" />,
//   },
//   {
//     target: '[data-tour="homeworks-table"]',
//     placement: responsivePlacement("top"),
//     disableBeacon: true,
//     isFinalStep: true,
//     speechText: "Your homeworks are listed here.",
//     content: <JoyrideContent en="Your homeworks are listed here." hi="यहाँ आपके होमवर्क दिखाए गए हैं।" />,
//   },
// ];

